// @givmo/app-admin — TanStack Query client factory (07-1.0 §3).
//
// One `QueryClient` per app instance (a factory, not a module singleton, so tests get a fresh client
// and there's no cross-test cache bleed). Defaults are conservative for an admin portal: a short
// stale window and a single retry — the api-client already surfaces `GivmoError` with a support
// reference, so aggressive retries would only delay an actionable error.

import { QueryClient } from '@tanstack/react-query';

export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        retry: 1,
        refetchOnWindowFocus: false,
      },
      mutations: {
        retry: 0,
      },
    },
  });
}
